export default __webpack_public_path__ + "static/media/Selectroster.ed4e3e86.svg";